import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { CommissionRecalculationTaskList } from './CommissionRecalculationTaskList/CommissionRecalculationTaskList';

export const commissionRecalculationTaskResource: ResourceProps = {
  name: Resources.CommissionRecalculationTasks,
  create: <></>,
  edit: <></>,
  show: <></>,
  list: CommissionRecalculationTaskList,
};
